export const ALL_USERS = ["user", "anonymous"];
export const REGISTERED_USERS = ["user"];
export const USER = "user";
export const ANONYMOUS = "anonymous";
